// Trace du DERNIER envoi email d'un devis OMV (lue depuis devis.email_envoi).
// « Envoyé » ne s'affiche QUE si status === "sent" (envoi réellement parti, point 1).
export default function DevisEnvoiTrace({ envoi, className = "" }) {
  if (!envoi || !envoi.status) return null;
  const d = String(envoi.sent_at || "").slice(0, 10);
  const base = `text-[11px] ${className}`;
  if (envoi.status === "sent") {
    return (
      <span className={base} style={{ color: "var(--oh-stat-green-text)" }} data-testid="devis-envoi-trace">
        ✅ Envoyé le {d}{envoi.recipient ? ` à ${envoi.recipient}` : ""}
      </span>
    );
  }
  if (envoi.status === "skipped_preprod") {
    return (
      <span className={base} style={{ color: "var(--oh-text-muted)" }} data-testid="devis-envoi-trace">
        Envoi simulé (preprod) le {d} — partira réellement en prod
      </span>
    );
  }
  return (
    <span className={base} style={{ color: "var(--oh-stat-red-text)" }} data-testid="devis-envoi-trace">
      ❌ Dernier envoi échoué le {d}{envoi.error ? ` : ${envoi.error}` : ""}
    </span>
  );
}
